import React from 'react';
import '../../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {getSchoolYear} from "../../../../../utils/authority";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../../services/system/student/student-controller";
import {GRADE_CONST} from "../../../../../components/Grade";

class modalSelectClassRoom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            yearId: parseInt(getSchoolYear()),
            listClassRoom: [],
            classIdTo: -1,
            studentIds: [],

            pageNumber: 0,
            pageSize: 500,
            page: 0,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){

            this.setState({
                studentIds:  nextProps.id,
                gradeId:  nextProps.gradeId,
            }, () =>{
                this.getListClassRoom()
            })
        }
    }
    onCreate = () => {
        let {fullName} = this.state;
        if (fullName == "" || fullName.length < 5){
            toast.error("Tên học sinh phải lớn hơn 6 ký tự");
        }else {
            let payload = {
                "wardCode": this.state.wardId,
                "yearId": parseInt(getSchoolYear()),
                "zone": this.state.zone
            }
            StudentController.create(payload, res => {
                if (res.success){
                    this.props.onHide();
                    this.props.onRefresh()
                    toast.success("Tạo học sinh thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    getListClassRoom = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onSave() {
        let payload = {
            classIdTo: parseInt(this.state.classIdTo),
            studentIds: this.state.studentIds,
        };
        StudentController.phanLop(payload, res => {
            this.props.onHide();
            if (res.success){
                toast.success("Phân lớp thành công!")
                this.props.onRefresh()
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getGradeName(){
        return GRADE_CONST[this.state.gradeId]
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÔNG BÁO</b></h1>
                        </div>

                        <div className='d-flex justify-content-center mt-3 mb-3 row'>
                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                <label className="label-item col-md-4">Khối</label>
                                <b className="label-item col-md-4">{this.getGradeName()}</b>
                            </div>
                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                <label className="label-item col-md-4">Lớp</label>
                                <select
                                    className="form-control kt-input pd-4-input hei-input"
                                    value={this.state.classIdTo}
                                    onChange={(e) => {
                                        this.state.classIdTo = e.target.value;
                                        this.setState({
                                            classIdTo: e.target.value,
                                            inEditing: true
                                        })
                                    }}
                                >
                                    <option value="0">Chọn lớp</option>
                                    {this.renderClassRoom()}
                                </select>
                            </div>
                        </div>


                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.onSave()}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Hủy bỏ
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default modalSelectClassRoom
